var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotGridIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 1,
    stroke: "black",
    strokeWidth: 2,
    transform: "rotate(90 4 4)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 4,
    r: 1,
    stroke: "black",
    strokeWidth: 2,
    transform: "rotate(90 12 4)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 4,
    r: 1,
    stroke: "black",
    strokeWidth: 2,
    transform: "rotate(90 20 4)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 12,
    r: 1,
    stroke: "black",
    strokeWidth: 2,
    transform: "rotate(90 4 12)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1,
    stroke: "black",
    strokeWidth: 2,
    transform: "rotate(90 12 12)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 12,
    r: 1,
    stroke: "black",
    strokeWidth: 2,
    transform: "rotate(90 20 12)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 20,
    r: 1,
    stroke: "black",
    strokeWidth: 2,
    transform: "rotate(90 4 20)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 20,
    r: 1,
    stroke: "black",
    strokeWidth: 2,
    transform: "rotate(90 12 20)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 1,
    stroke: "black",
    strokeWidth: 2,
    transform: "rotate(90 20 20)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotGridIcon);
export default __webpack_public_path__ + "static/media/dot_grid_icon.00515e2b374b6b0543bfee33d0e72aec.svg";
export { ForwardRef as ReactComponent };